import { render, staticRenderFns } from "./Kirchenvorstand.vue?vue&type=template&id=09398ae8&scoped=true&"
import script from "./Kirchenvorstand.vue?vue&type=script&lang=js&"
export * from "./Kirchenvorstand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09398ae8",
  null
  
)

export default component.exports